import { colors } from "@areahub/theme";
import { StackProps } from "@chakra-ui/react";
import {
  DefaultControls,
  DynamicLegend,
  MapWrapper,
  UserLocationPin,
} from "@ui/maps/common/src";
import Map, { Layer, Source } from "react-map-gl";
import DistancePopup from "./distance-popup";
import { useHazardMap, UseHazardMapOptions } from "./hooks/use-hazard-maps";

export interface HazardMapProps extends UseHazardMapOptions {
  url: string;
  wrapperProps?: StackProps;
  mapboxAccessToken?: string;
}

export const HazardMap = ({ url, wrapperProps, ...props }: HazardMapProps) => {
  const {
    onLoad,
    ref,
    buffer,
    initialViewState,
    resetViewState,
    legendRows,
    hovered,
    onMouseMove,
  } = useHazardMap(url, props);
  return (
    <MapWrapper
      sx={{
        ".mapboxgl-popup-close-button": {
          display: "none",
        },
      }}
      position="relative"
      {...wrapperProps}
    >
      <Map
        ref={ref}
        onLoad={onLoad}
        onMouseMove={onMouseMove}
        initialViewState={initialViewState}
        mapboxAccessToken={
          props?.mapboxAccessToken ||
          process.env.NEXT_PUBLIC_CLIENT_MAPBOX_ACCESS_TOKEN
        }
        attributionControl={false}
        // disable pitch
        maxPitch={0}
        // disable rotation
        dragRotate={false}
        // disable scroll zooming
        scrollZoom={false}
        mapStyle={
          "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json"
        }
        style={{ height: "100%", width: "100%" }}
        interactiveLayerIds={[props.category]}
      >
        <Source
          {...{
            id: "radius",
            data: buffer,
            type: "geojson",
          }}
        >
          <Layer
            type="fill"
            paint={{
              "fill-opacity": 0.25,
              "fill-color": colors.blue[300],
            }}
            id="radius"
          />
        </Source>
        <DefaultControls resetViewport={resetViewState} />

        <DynamicLegend
          legendRows={legendRows}
          position="absolute"
          bottom="1"
          left="1"
          inverted
        />

        <UserLocationPin userLocation={props.userLocation} />
        {hovered && <DistancePopup {...hovered} />}
      </Map>
    </MapWrapper>
  );
};
